module.exports = __webpack_public_path__ + "static/media/placeholder.80a10760.jpg";